export default __webpack_public_path__ + "f0e072ea60c7c9b15cdeecafdeb770e4.xlsx";